import { Currency } from '@vy/types';
import Big from 'big.js';
import { ReactNode } from 'react';

export type FormatStyle = 'percent' | 'currency' | 'unit' | 'decimal';

export function generateNumberToDisplay(
  children: number | ReactNode,
  formattingStyle: FormatStyle,
  currency: Currency | undefined,
  fractionDigits?: number,
) {
  const isCurrency = formattingStyle === 'currency';
  const numberValue = Number(children);

  if (!isFinite(numberValue) || !isCurrency) {
    return { numberToDisplay: children, shouldDisplayTooltip: false };
  }

  const bigNumberValue = Big(numberValue);
  const truncatedStringValue = bigNumberValue.times(100).round(0, 0).div(100).toPrecision(16);
  const truncatedValue = Number(truncatedStringValue);

  const isSameNumber = children === truncatedValue;
  const shouldDisplayTooltip = isCurrency && !isSameNumber;

  const numberToDisplay = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencySign: 'accounting',
    minimumFractionDigits: fractionDigits ?? 0,
    maximumFractionDigits: fractionDigits ?? 2,
  }).format(truncatedValue);

  return {
    shouldDisplayTooltip,
    numberToDisplay,
  };
}
